import { useState } from "react";
import { PageHeader, useApi } from "@/components/common";
import AuditTable from "@/components/AuditTable";

export default function PlatformAuditView() {
  const [filters, setFilters] = useState({ q: "", severity: "", page: 1 });
  const qs = new URLSearchParams({ page: filters.page, limit: 25, ...(filters.q && { q: filters.q }), ...(filters.severity && { severity: filters.severity }) }).toString();
  const audit = useApi(`/platform/audit?${qs}`);
  return (
    <div>
      <PageHeader eyebrow="Platform" title="Global audit log" subtitle="Every tenant, every platform action, every impersonation — with actor, IP, before/after." testId="platform-audit" />
      <AuditTable data={audit.data} loading={audit.loading} filters={filters} setFilters={setFilters} showTenant />
    </div>
  );
}
